import styles from '@components/components/CmsComponents/components/CmsIcon/CmsIcon.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeProIcon } from '@wienenergiegithub/ui-next';

const sizeMap = {
  tiny: '1x',
  small: '2x',
  regular: '3x',
  medium: '5x',
  large: '8x',
};

const CmsIcon = ({ icon, type, sizing, variant }) => (
  <FontAwesomeProIcon
    className={classNames(styles.icon, styles[variant])}
    icon={icon}
    role="presentation"
    size={sizeMap[sizing]}
    type={type}
  />
);

CmsIcon.defaultProps = {
  sizing: 'regular',
  type: 'solid',
  variant: 'secondary',
};

CmsIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  sizing: PropTypes.oneOf(['tiny', 'small', 'regular', 'medium', 'large']),
  type: PropTypes.oneOf(['solid', 'light', 'brand', 'regular']),
  variant: PropTypes.string,
};

export default CmsIcon;
